import { render, staticRenderFns } from "./Comp5.vue?vue&type=template&id=151084d2&scoped=true&"
import script from "./Comp5.vue?vue&type=script&lang=js&"
export * from "./Comp5.vue?vue&type=script&lang=js&"
import style0 from "./Comp5.vue?vue&type=style&index=0&id=151084d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151084d2",
  null
  
)

export default component.exports